var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2133_24701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.19182 7.74509L4.39053 1.25216L2.00334 3.69271",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.21817 1.25216L6.01946 7.74509L8.40665 5.30453",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2133_24701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.65145,
    height: 9.45713,
    fill: "white",
    transform: "translate(0.879395 0.201416)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedIcon);
export default __webpack_public_path__ + "static/media/SpeedIcon.f3b618cc6ff9943dac106cb8a6c9f9f5.svg";
export { ForwardRef as ReactComponent };